export default __webpack_public_path__ + "static/media/Machine Icon, Grey.d8f74cb6.png";